<template>
  <label>Horario</label>
  <div class="horarios">
    <div
      v-for="h in horarios"
      class="boton-horario"
      :class="{ selected: h.horario == horarioSelected, disabled: h.disabled }"
      @click="selectHorario(h)"
    >
      <div>{{ h.horario }}</div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  horarios: {
    type: Array,
    required: true,
  },
  horarioSelected: {
    type: String,
  },
})

const emit = defineEmits({ select: "String" })
const selectHorario = (h) => {
  if (!h.disabled) {
    emit("select", h.horario)
  }
}
</script>
<style>
.horarios {
  display: flex;
  justify-content: space-between;
  text-align: center;
  flex-wrap: wrap;
  gap: 20px;
}

.boton-horario {
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #000000;
  width: 76px;
  height: 40px;
  background-color: #ffffff;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0px 3px 6px #a8a8a829;
}

.selected {
  color: #ffffff;
  background-color: #1a9bfa;
  box-shadow: 0px 3px 6px #a8a8a829;
}

.disabled {
  background-color: #ededed;
}

.disabled div {
  color: #b7b7b7;
}
</style>
